<template>
    <div>
        <div class="search-header">
            <div class="columns is-mobile is-align-items-center">
                <div class="column is-9-mobile is-6-desktop">
                    <h2 class="is-flex is-align-items-center">
                    <strong>
                        <div class="header-left">
                            <span class="circle-number" :class="[ind > 9999 ? 'big-number' : '']">{{ind + 1}}</span>
                            <router-link v-if="isWatchlist" v-tooltip="'Click to see fund details'" class="has-text-underline header-title" :to="{name:'Detailedview Shortlist',params:{id:i.ISIN}}">{{ getShort(i.FundBasicsName) }}</router-link>
                            <router-link v-else v-tooltip="'Click to see fund details'" class="has-text-underline header-title" :to="{name:'Detailedview Results',params:{id:i.ISIN, text: convertURL(getShort(i.FundBasicsName))},query:{source:'search', id: $route.params.id}}">{{ getShort(i.FundBasicsName)}} </router-link>
                        </div>
                    </strong>
                    </h2>
                </div>
                <div class="column is-3-mobile is-3-desktop">
                    <div class="is-flex is-gap-6 is-justify-content-space-between is-align-items-center" style="gap:10px">
                        <span>{{ i.CurrencyId }}</span>
                        <b-dropdown class="dropdown-blog" position="is-bottom-left" v-if="i.blogs" aria-role="list">
                            <button class="font-weight-700 text-blue btn-blog" slot="trigger">
                                <span @click="getBlog(i.fund_id)">Blog</span>
                            </button>
                            <b-dropdown-item v-for="(blog, index) in fundsWithBlogs" class="is-flex-wrap-nowrap" :key="index" aria-role="listitem" :href="blog.bloglink" target="_blank">
                                <span class="mdi mdi-circle"></span>
                                {{ blog.blogtitle }} ({{formatDateTime(blog.blogdate,'yyyy-MM-DD')}})
                            </b-dropdown-item>
                        </b-dropdown>
                        <b-dropdown class="dropdown-blog" position="is-bottom-left" v-if="i.news" aria-role="list">
                            <button class="font-weight-700 text-blue btn-blog" slot="trigger">
                                <span @click="getNews(i.fund_id)">News</span>
                            </button>
                            <b-dropdown-item v-for="(news, index) in fundsWithNews" class="is-flex-wrap-nowrap" :key="index" aria-role="listitem" :href="news.newslink" target="_blank">
                                <span class="mdi mdi-circle"></span>
                                {{ news.newstitle }} ({{ formatDateTime(news.newsdate,'yyyy-MM-DD') }} | {{ news.newspublisher }})
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
                <div class="column is-3-desktop is-hidden-mobile">
                    <div class="is-flex is-align-items-center is-justify-content-end is-flex-direction-row-reverse" style="height: 100%;">
                        <Buttons :selectedWatchlistID="selectedWatchlistID" :ISIN="i.ISIN" :fund-id="i.fund_id" :fund_data="i" :ind="ind"></Buttons>
                    </div>
                </div>
            </div>
        </div>
        <div class="search-content">
            <div class="columns mb-0">
                <div class="column is-10-tablet p-t-0-mobile">
                    <div class="columns">
                        <div class="column is-7-tablet p-t-0-mobile">
                            <div id="load-fixed" class="columns is-flex is-justify-content-flex-start">
                                <div class="column is-3-mobile">
                                    <label class="px-1">1 YR<button v-tooltip="{content: 'Annualised Net Total Return 1 Year', trigger: 'hover click'}">?</button></label>
                                    <pos-neg :val="i.CumulativeTotalReturn1Year" :suffix="'%'"></pos-neg>
                                    <div v-if="filterBenchmarkSelected && (i.CumulativeTotalReturn1Year || i.CumulativeTotalReturn1Year === 0)" class="mt-2">
                                        <pos-neg :val="i.CumulativeTotalReturn1Year - filterBenchmarkSelected.benchmark1Y" :suffix="'%'" :class="'is-size-6'" :bg-color="benchmarkHighlightColor"></pos-neg>
                                    </div>
                                </div>
                                <div class="column is-3-mobile">
                                    <label class="px-1">3 YR<button v-tooltip="{content: 'Annualised Net Total Return 3 Year', trigger: 'hover click'}">?</button></label>
                                    <pos-neg :val="i.TotalReturn3Years" :suffix="'%'"></pos-neg>
                                    <div v-if="filterBenchmarkSelected && (i.TotalReturn3Years || i.TotalReturn3Years === 0)" class="mt-2">
                                        <pos-neg :val="i.TotalReturn3Years - filterBenchmarkSelected.benchmark3Y" :suffix="'%'" :bg-color="benchmarkHighlightColor"></pos-neg>
                                    </div>

                                </div>
                                <div class="column is-3-mobile">
                                    <label class="px-1">5 YR<button v-tooltip="{content: 'Annualised Net Total Return 5 Year', trigger: 'hover click'}">?</button></label>
                                    <pos-neg :val="i.TotalReturn5Years" :suffix="'%'"></pos-neg>
                                    <div v-if="filterBenchmarkSelected && (i.TotalReturn5Years || i.TotalReturn5Years === 0)" class="mt-2">
                                        <pos-neg :val="i.TotalReturn5Years - filterBenchmarkSelected.benchmark5Y" :suffix="'%'" :bg-color="benchmarkHighlightColor"></pos-neg>
                                    </div>
                                </div>
                                <div class="column is-3-mobile">
                                    <label class="px-1">YTD<button v-tooltip="{content: 'Year To Date Return', trigger: 'hover click'}">?</button></label>
                                    <pos-neg :val="i.CumulativeTotalReturnTD" :suffix="'%'"></pos-neg>
                                    <div v-if="filterBenchmarkSelected && (i.CumulativeTotalReturnTD || i.CumulativeTotalReturnTD === 0)" class="mt-2">
                                        <pos-neg :val="i.CumulativeTotalReturnTD - filterBenchmarkSelected.benchmarkTD" :suffix="'%'" :bg-color="benchmarkHighlightColor"></pos-neg>
                                    </div>
                                </div>
                            </div>
                            <!--
                            <div class="columns is-mobile is-hidden-mobile">
                                <div class="column is-12-mobile p-t-20-tablet pb-3">
                                    <label>Annualised Net Total Returns {{show[i]}}</label>
                                </div>
                            </div>
                            -->
                        </div>
                        <div class="column is-5-tablet pb-0">
                            <div class="columns is-flex is-justify-content-flex-start is-align-items-start mb-0">
                                <div class="column is-3-mobile is-hidden-tablet">
                                    <span v-if="i.IndexFund" class="label"
                                        v-tooltip="{content: 'Management Style', trigger: 'hover click'}" style="background-color: #AFEF97; color: #363636;">Passive</span>
                                    <span class="label active" v-else  v-tooltip="{content: 'Management Style', trigger: 'hover click'}"
                                    >Active</span>
                                </div>

                                <div class="column is-3-mobile">
                                    <label class="px-1">OGC<button v-tooltip="{content: 'Ongoing Charge (includes Mgt Fee)', trigger: 'hover click'}">?</button></label>
                                    <pos-neg :val="i.ongoingchargecomp" :suffix="'%'"></pos-neg>

                                </div>
                                <div class="column is-3-mobile">
                                    <label class="px-1">Yield<button v-tooltip="{content: '12m Yield', trigger: 'hover click'}">?</button></label>
                                    <pos-neg :val="i.yield12m" :suffix="'%'"></pos-neg>

                                </div>
                                <div class="column is-3-mobile">
                                    <label>Net Assets<button v-tooltip="{content: 'Fund Net assets', trigger: 'hover click'}">?</button></label>
                                    <span class="is-lowercase">{{ currency("GBP", parseNA(i.fundnetassetgbp)) }}M</span>
                                </div>



                                <div class="is-hidden-mobile is-hidden-tablet pl-2">
                                    <div class="is-flex is-flex-direction-column is-justify-content-start is-align-items-flex-start">
                                        <span><small>{{ gcats(i.CategoryId) }}</small></span>
                                    </div>
                                </div>
                            </div>
                            <div class="columns is-hidden-tablet m-b-10-mobile">
                                <div class="column is-12-mobile pt-0 p-t-20-tablet p-b-0-mobile">
                                    <hr style="background-color: #ddd; height: 1px; margin: .1em 0 .2em 0;">
                                    <div class="is-flex">
                                        <div v-if="checkLabelSorting1" class="sorting-mobile">
                                            <div class="sorting-mobile__label">
                                                <span>{{checkLabelSorting1}}:</span>
                                            </div>
                                            <div class="sorting-mobile__value">
                                                <span v-if="checkValueSorting1 === 1">
                                                    {{i[keySortingLevel_1]}}y
                                                </span>
                                                <span v-if="checkValueSorting1 === 2">
                                                    <span v-if="i[keySortingLevel_1]">{{i[keySortingLevel_1]}}</span>
                                                    <span v-else class="not-available">n/a</span>
                                                </span>
                                                <span v-if="checkValueSorting1 === 3">
                                                    <pos-neg :val="i[keySortingLevel_1]" :suffix="'%'"></pos-neg>
                                                </span>
                                                <span v-if="checkValueSorting1 === 4">
                                                    <span v-if="i[keySortingLevel_1]"><img class="no-yes-custom" src="/img/tick.svg"></span>
                                                    <span v-else><img class="no-yes-custom" src="/img/cross.svg"></span>
                                                </span>
                                                <span v-if="checkValueSorting1 === 5">
                                                    <span v-if="i[keySortingLevel_1]">{{i[keySortingLevel_1]}}y</span>
                                                    <span v-else class="not-available">n/a</span>
                                                </span>
                                            </div>
                                        </div>
                                        <div v-if="checkLabelSorting2" class="sorting-mobile">
                                            <div class="sorting-mobile__label">
                                                <span>{{checkLabelSorting2}}:</span>
                                            </div>
                                            <div class="sorting-mobile__value">
                                                <span v-if="checkValueSorting2 === 1">
                                                    {{i[keySortingLevel_2]}}y
                                                </span>
                                                <span v-if="checkValueSorting2 === 2">
                                                    {{i[keySortingLevel_2]}}
                                                </span>
                                                <span v-if="checkValueSorting2 === 3">
                                                    <pos-neg :val="i[keySortingLevel_2]" :suffix="'%'"></pos-neg>
                                                </span>
                                                <span v-if="checkValueSorting2 === 4">
                                                    <span v-if="i[keySortingLevel_2]"><img class="no-yes-custom" src="/img/tick.svg"></span>
                                                    <span v-else><img class="no-yes-custom" src="/img/cross.svg"></span>
                                                </span>
                                                <span v-if="checkValueSorting2 === 5">
                                                    <span v-if="i[keySortingLevel_2]">{{i[keySortingLevel_2]}}y</span>
                                                    <span v-else class="not-available">n/a</span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="category-mobile">
                                            <span class="is-size-6" v-tooltip="{content: 'Category', trigger: 'hover'}">
                                                <small v-if="i.morningstarcategories">{{ i.morningstarcategories }}</small>
                                                <small v-else class="not-available">n/a</small>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column is-2-tablet is-hidden-mobile">
                    <div v-if="!inShortlist" class="pl-0 is-flex is-justify-content-flex-end">
                        <button @click="addShortList(i)" class="btn float-right is-hidden-mobile" v-tooltip="{content: 'Save to your Shortlist', trigger: 'hover click'}">SHORTLIST</button>
                    </div>
                    <div v-else class="pl-0 is-flex is-justify-content-flex-end">
                        <button @click="$store.dispatch('shortlist/remove',i.ISIN)" class="btn float-right is-hidden-mobile is-uppercase btn-alt" v-tooltip="{content: 'Remove from your Shortlist', trigger: 'hover click'}">
                        <template v-if="$store.state.shortlist.showShortlist">
                            REMOVE
                        </template>
                         <template v-else>
                            SHORTLISTED
                         </template>
                        </button>
                    </div>
                </div>
            </div>
            <div v-show="show" class="columns mt-1 m-t-0-mobile">
                <div class="column is-12-mobile is-10-tablet pt-1 pb-1 p-t-0-mobile">
                    <div class="is-flex is-justify-content-space-between is-flex-wrap-wrap">
                        <div class="">
                            <span><small v-tooltip="{content: i.CompanyBasicsName, trigger: 'hover click'}">{{ i.am_short }}</small><button v-tooltip="{content: 'Asset Manager', trigger: 'hover click'}">?</button></span>
                        </div>
                        <div class="">
                            <span>{{ glegal(i.LegalStructure) }}<button v-tooltip="{content: 'Fund\'s Legal Structure', trigger: 'hover click'}">?</button></span>
                        </div>
                        <div class="is-hidden-mobile">
                            <label>Risk Rating<button v-tooltip="{content: 'Morningstar Risk Rating. From 1-5... 1=lower risk, 5=higher risk', trigger: 'hover click'}">?</button></label>
                            <span v-if="i.riskrating_6M" class="">{{ i.riskrating_6M }}</span>
                            <span v-else class="not-available">n/a</span>
                        </div>
                        <div class="is-hidden-tablet">
                            <div class="is-flex is-justify-content-space-between is-align-items-flex-end">
                                <label class="is-inline mr-2">Risk Rating<button v-tooltip="{content: 'Morningstar Risk Rating. From 1-5... 1=lower risk, 5=higher risk', trigger: 'hover click'}">?</button></label>
                                <span v-if="i.riskrating_6M" class="">{{ i.riskrating_6M }}</span>
                                <span v-else class="not-available">n/a</span>
                            </div>
                        </div>
                        <div class="is-hidden-mobile">
                            <div class="is-flex is-justify-content-space-between is-align-items-flex-end">
                                <div>
                                    <label>3Y Sharpe<button v-tooltip="{content: '3Y Sharpe Ratio', trigger: 'hover click'}">?</button></label>
                                    <span>
                                        <small v-if="i.sharperatio3Y" :class="i.sharperatio3Y < 0 ? 'red' : 'black'">{{ i.sharperatio3Y }}</small>
                                        <small v-else>n/a</small>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="is-hidden-mobile">
                            <div class="is-flex is-justify-content-space-between is-align-items-flex-end">
                                <div>
                                    <label>ISIN<button v-tooltip="{content: 'Unique identifier. Usually found at the top of all investor documents', trigger: 'hover click'}">?</button></label>
                                    <span><small>{{ isisin(i.ISIN) }}</small></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column is-2-tablet pt-0">
                    <div class="is-flex is-justify-content-space-between is-align-items-center mb-3 m-b-0-tablet">
                        <div class="is-hidden-tablet">
                            <div class="is-flex is-justify-content-space-between is-align-items-flex-end">
                                <div>
                                    <label class="is-inline mr-2">3Y Sharpe<button v-tooltip="{content: '3Y Sharpe', trigger: 'hover click'}">?</button></label>
                                    <span>
                                        <small v-if="i.sharperatio3Y" :class="i.sharperatio3Y < 0 ? 'red' : 'black'">{{ i.sharperatio3Y }}</small>
                                        <small v-else>n/a</small>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="is-hidden-tablet">
                            <div class="is-flex is-justify-content-space-between is-align-items-flex-end">
                                <div>
                                    <label class="is-inline mr-2">ISIN<button v-tooltip="{content: 'Unique identifier. Usually found at the top of all investor documents', trigger: 'hover click'}">?</button></label>
                                    <span><small>{{ isisin(i.ISIN) }}</small></span>
                                </div>
                            </div>
                        </div>
                        <!-- <button @click="soonModalActive = true" v-show="show" class="no-tooltip no-border p-0 has-tooltip is-size-7" style="color: #009bde; background: transparent;" v-tooltip="'Coming soon'">Factsheet <img style="width: 16px; height: auto" src="/img/download.svg"></button> -->
                    </div>
                </div>
            </div>

            <div class="columns mb-0">
                <div class="column is-10-tablet py-0">
                    <hr class="is-hidden-mobile" style="background-color: #ddd; height: 1px; margin: .5em 0;">
                    <div class="columns is-flex is-hidden-mobile is-justify-content-space-between">
                        <div class="column is-2">
                            <span v-if="i.IndexFund" class="label px-3 mt-0"
                                    v-tooltip="'Management Style'" style="background-color: #AFEF97; color: #363636; width: 70px !important">Passive</span>
                            <span class="label active px-3 mt-0" v-else  v-tooltip="'Management Style'" style="width: 65px !important"
                            >Active</span>
                        </div>
                        <div v-if="checkLabelSorting1" class="column sorting-option" :class="checkLabelSorting2 ? 'is-2' : ''">
                            <div class="sorting-option__label">
                                <span><label>{{checkLabelSorting1}}:</label></span>
                            </div>
                            <div class="sorting-option__value">
                                <span v-if="checkValueSorting1 === 1">
                                    {{i[keySortingLevel_1]}}y
                                </span>
                                <span v-if="checkValueSorting1 === 2">
                                    <span v-if="i[keySortingLevel_1]">{{i[keySortingLevel_1]}}</span>
                                    <span v-else class="not-available">n/a</span>
                                </span>
                                <span v-if="checkValueSorting1 === 3">
                                    <pos-neg :val="i[keySortingLevel_1]" :suffix="'%'"></pos-neg>
                                </span>
                                <span v-if="checkValueSorting1 === 4">
                                    <span v-if="i[keySortingLevel_1]"><img class="no-yes-custom" src="/img/tick.svg"></span>
                                    <span v-else><img class="no-yes-custom" src="/img/cross.svg"></span>
                                </span>
                                <span v-if="checkValueSorting1 === 5">
                                    <span v-if="i[keySortingLevel_1]">{{i[keySortingLevel_1]}}y</span>
                                    <span v-else class="not-available">n/a</span>
                                </span>
                            </div>
                        </div>
                        <div v-if="checkLabelSorting2" class="column sorting-option">
                            <div class="sorting-option__label">
                                <span><label>{{checkLabelSorting2}}:</label></span>
                            </div>
                            <div class="sorting-option__value">
                                <span v-if="checkValueSorting2 === 1">
                                    {{i[keySortingLevel_2]}}y
                                </span>
                                <span v-if="checkValueSorting2 === 2">
                                    {{i[keySortingLevel_2]}}
                                </span>
                                <span v-if="checkValueSorting2 === 3">
                                    <pos-neg :val="i[keySortingLevel_2]" :suffix="'%'"></pos-neg>
                                </span>
                                <span v-if="checkValueSorting2 === 4">
                                    <span v-if="i[keySortingLevel_2]"><img class="no-yes-custom" src="/img/tick.svg"></span>
                                    <span v-else><img class="no-yes-custom" src="/img/cross.svg"></span>
                                </span>
                                <span v-if="checkValueSorting2 === 5">
                                    <span v-if="i[keySortingLevel_2]">{{i[keySortingLevel_2]}}y</span>
                                    <span v-else class="not-available">n/a</span>
                                </span>
                            </div>
                        </div>
                        <div class="column" style="text-align: right">
                            <span class="is-size-6" v-tooltip="'Category'">
                                <small v-if="i.morningstarcategories">{{ i.morningstarcategories }}</small>
                                <small v-else class="not-available">n/a</small>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="column is-2-tablet is-hidden-mobile">
                    <div class="show-hide is-pulled-right">
                        <a v-if="show" @click="show=false" v-tooltip="'Collapse'" class="show"><img class="img-hide" src="/img/show.svg"></a>
                        <a v-else @click="show=true" v-tooltip="'Expand'" class="hide"><img src="/img/hide.svg"></a>
                    </div>
                </div>
            </div>
            <div class="columns is-tablet m-b-5-mobile">
                <div class="column is-10-tablet p-t-0-tablet p-b-0-tablet m-t-10-mobile">
                    <div class="is-flex is-align-items-center is-justify-content-end is-flex-direction-row-reverse">
                        <div class="show-hide is-pulled-right is-hidden-tablet">
                            <a v-if="show" @click="show=false" v-tooltip="'Collapse'" class="show"><img class="img-hide" src="/img/show.svg"></a>
                            <a v-else @click="show=true" v-tooltip="'Expand'" class="hide"><img src="/img/hide.svg"></a>
                        </div>

                        <div v-if="!inShortlist" class="is-hidden-tablet ml-3">
                            <button @click="addShortList(i)" class="btn float-right">SHORTLIST</button>
                        </div>
                        <div v-else class="is-hidden-tablet ml-3">
                            <button @click="$store.dispatch('shortlist/remove',i.ISIN)" class="btn float-right btn-alt">
                            <template v-if="$store.state.shortlist.showShortlist">
                                REMOVE
                            </template>
                            <template v-else>
                                SHORTLISTED
                            </template>
                            </button>
                        </div>

                        <div class="buttons-actions is-hidden-tablet">
                            <buttons :ISIN="i.ISIN" :fund-id="i.fund_id" :fund_data="i" :ind="ind"/>
                        </div>
                    </div>
                </div>
                <div class="column is-2-tablet is-hidden-mobile p-t-0-tablet p-b-0-tablet">
                </div>

            </div>
        </div>
        <b-modal
            v-model="soonModalActive"
            has-modal-card
            trap-focus
            :destroy-on-hide="false"
            aria-role="dialog"
            aria-label="Example Modal"
            aria-modal>
            <template >
                <div class="modal-card" style="width: auto">
                    <section class="modal-card-body py-5 px-6">
                        <button
                            type="button"
                            class="delete"
                            @click="soonModalActive=false"/>
                        <h3 class="has-text-centered dark-text">Coming soon!</h3>
                    </section>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<style scoped>
.search-header .dropdown-menu {
    max-width: 500px;
}
.header-left {
    display: flex;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
}
.header-title {
    flex: 1;
}
.circle-number {
    display: inline-flex;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    color: #009BDE;
    background: transparent;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    border: 1px solid #009BDE;
}
.circle-number.big-number {
    font-size: 11px;
}
.btn-blog {
    background: #b9ede8;
    padding: 10px;
    border: none;
    color: #009BDE;
    font-size: 18px;
}
.dropdown-blog a {
    flex-wrap: wrap;
    white-space: normal;
    text-align: left;
    width: 500px;
    padding: 10px;
    max-width: 100%;
    color: #009BDE;
}
.dropdown-item .mdi-circle {
    font-size: 10px;
    min-width: 10px;
}
.dropdown-item:hover .mdi-circle {
    color: inherit;
}
</style>
<script>
import commonMixin from "@/mixins/commonMixin";
import Buttons from "@/components/Buttons";
import PosNeg from "@/components/PosNeg";
import axios from "axios";

export default {
    name: 'SearchResult',
    components: {PosNeg, Buttons},
    props:{
        i:Object,
        showall:Boolean,
        selectedWatchlistID: Number,
        shortlist: Boolean,
        filterBenchmarkSelected: Object,
        isWatchlist:{
            type:Boolean,
            default:false
        },
        ind: Number
    },
    mixins: [commonMixin],
    data(){
        return{
            show:false,
            soonModalActive: false,
            benchmarkHighlightColor: '#FFFE00',
            fundsWithBlogs: [],
            fundsWithNews: []
        }
    },
    computed:{
        inShortlist(){
            if(this.$store.state.shortlist.myShortlist.length && this.$store.state.shortlist.myShortlist.includes(this.i.ISIN)){
                return true
            }
            return false
        },
        keySortingLevel_1() {
            return this.$store.state.search.searchData.sort.level_1.field;
        },

        keySortingLevel_2() {
            return this.$store.state.search.searchData.sort.level_2.field;
        },
        checkLabelSorting1() {
            switch (this.$store.state.search.searchData.sort.level_1.label) {
                case "years_since_launch":
                    return "Years since launch";
                case "manager tenure":
                    return "Manager tenure";
                case "NumberOfHolding":
                    return "Holdings";
                case "standarddev36m":
                    return "3Y SD";
                case "premium/discount to NAV":
                    return "Prem/Disc to NAV";
                case "ETF / non ETF":
                    return "ETF";
                default:
                    return false;
            }
        },
        checkLabelSorting2() {
            switch (this.$store.state.search.searchData.sort.level_2.label) {
                case "years_since_launch":
                    return "Years since launch";
                case "manager tenure":
                    return "Manager tenure";
                case "NumberOfHolding":
                    return "Holdings";
                case "standarddev36m":
                    return "3Y SD";
                case "premium/discount to NAV":
                    return "Prem/Disc to NAV";
                case "ETF / non ETF":
                    return "ETF";
                default:
                    return false;
            }
        },
        checkValueSorting1() {
            switch (this.$store.state.search.searchData.sort.level_1.label) {
                case "years_since_launch":
                    return 1;
                case "NumberOfHolding":
                    return 2;
                case "standarddev36m":
                case "premium/discount to NAV":
                    return 3;
                case "ETF / non ETF":
                    return 4;
                case "manager tenure":
                    return 5;
                default:
                    return false;
            }
        },
        checkValueSorting2() {
            switch (this.$store.state.search.searchData.sort.level_2.label) {
                case "years_since_launch":
                    return 1;
                case "NumberOfHolding":
                    return 2;
                case "standarddev36m":
                case "premium/discount to NAV":
                    return 3;
                case "ETF / non ETF":
                    return 4;
                case "manager tenure":
                    return 5;
                default:
                    return false;
            }
        },
        benchmarkFilterSelected() {
            return this.$store.state.search.compareBenchmarkFilter
        }

    },
    methods: {
        addShortList(fund) {
            axios.get('/search/saveshortlistdata',
                {
                    params: {
                        ISIN: fund.ISIN,
                        toggle: this.$store.state.search.currency
                    }
                }
            )
            this.$store.commit('shortlist/ADD_LIST', fund.ISIN);
        },
        getBlog(fund_id) {
            axios.get('/fund-blogs/'+fund_id)
            .then((response) => {
                this.fundsWithBlogs = response.data
            })
        },
        getNews(fund_id) {
            axios.get('/fund-news/'+fund_id)
            .then((response) => {
                this.fundsWithNews = response.data
            })
        }
    },
    watch:{
        showall:function(n){
            this.show = n
        }
    },
    mounted() {
        this.show = this.showall;
    }
}
</script>
